import { BaseLandlordSurvey } from "api/landlord-surveys/types/types";
import { Card } from "shared/components/Card";
import { DateTime } from "luxon";
import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import { ContextMenuPopover } from "shared/components/ContextMenuPopover";

export const SurveyCard = (props: BaseLandlordSurvey) => {
  return (
    <Card
      className="min-w-[373px]"
      linkTo={`/landlord-surveys/${props.identifier}`}
    >
      <main className="w-full h-16 px-6 border-b border-alpha-40 flex items-center gap-3">
        <h1 className="text-base text-content-1000 font-bold">{props.name}</h1>
        <div className="ml-auto translate-x-2">
          <ContextMenuPopover
            borderLess
            actions={[
              {
                title: "Make default",
                disabled: props.is_default,
                tooltip: "Already default template",
                onClick: () => {
                  //
                }
              },
              {
                title: "Edit",
                onClick: () => {
                  //
                }
              },
              {
                title: "Duplicate",
                onClick: () => {
                  //
                }
              },
              {
                title: "Delete",
                className: "text-danger-500",
                onClick: () => {
                  //
                }
              }
            ]}
          />
        </div>
      </main>
      <footer className="flex h-[52px] px-6 gap-2 justify-between items-center">
        <span className="text-xs text-content-300 font-medium">
          Updated: {DateTime.fromISO(props.updated_at).toFormat("DD")}
        </span>

        <Show if={props.is_default}>
          <Badge variant={BadgeVariant.PRIMARY} size={BadgeSize.SM}>
            Default
          </Badge>
        </Show>
      </footer>
    </Card>
  );
};
